import * as L from "leaflet";
import ILayerStyle from "./ILayerStyle";

export default class SectorDefinitionStyle implements ILayerStyle {
    public getOptions = (): L.GeoJSONOptions => {
        return {
            style: () => {
                return {
                    color: "red",
                    fillOpacity: 0,
                    interactive: false,
                };
            },
        }
    };
}